'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
var baseIcon = require('../base-icon/base-icon.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledFontIcon = (props)=>{
    const { 'aria-hidden': ariaHidden , 'aria-label': ariaLabel , className , color , icon , iconSize , position , reverse , style , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(baseIcon.BaseIcon, _extends({}, otherProps, {
        "aria-hidden": ariaLabel ? false : ariaHidden,
        "aria-label": ariaLabel,
        className: classnames__default.default({
            'bf-icon__font': true,
            [`bff-${icon}`]: icon,
            [`bf-icon__font--${color}`]: !!color,
            [`bf-icon__font--position-${position}`]: !!position,
            ['bf-icon__font--reverse']: reverse,
            [`${className}`]: !!className
        }),
        style: {
            ...style,
            fontSize: iconSize === undefined ? undefined : `${iconSize}px`
        }
    }));
};
const rotate = styled.keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
const StyledFontIcon = styled__default.default(UnstyledFontIcon)`
  background: transparent; // removes background from icons in firefox
  display: inline-block;
  font-family: 'bff' !important;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  line-height: 1;
  speak: never;
  text-rendering: auto;
  text-transform: none;
  transform: translate(0, 0);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.bf-icon__font--reverse {
    transform: rotateY(180deg);
  }

  &.bf-icon__font--position-left {
    padding-right: 6px;
  }

  &.bf-icon__font--position-right {
    padding-left: 6px;
  }

  &.bf-icon__font--danger {
    color: ${colors.BrandfolderHexColors.Delete};
  }

  &.bf-icon__font--primary {
    color: ${colors.BrandfolderHexColors.PurplePopsicle};
  }

  &.bf-icon__font--text {
    color: ${colors.BrandfolderHexColors.Text};
  }

  &.bf-icon__font--warning {
    color: ${colors.BrandfolderHexColors.WarningRed};
  }

  &.bf-icon__font--white {
    color: ${colors.BrandfolderHexColors.White};
  }

  &.bff-boards:before {
    content: '\\e91d';
  }

  &.bff-arrow-down-up:before {
    content: '\\e900';
  }

  &.bff-bar-graph:before {
    content: '\\e901';
  }

  &.bff-logo:before {
    content: '\\e902';
    color: #40d1f5;
  }

  &.bff-settings:before {
    content: '\\e903';
  }

  &.bff-build:before {
    content: '\\e904';
  }

  &.bff-calendar:before {
    content: '\\e905';
  }

  &.bff-check-mark:before {
    content: '\\e906';
  }

  &.bff-close:before {
    content: '\\e907';
  }

  &.bff-caret-left:before {
    content: '\\e908';
  }

  &.bff-color-hexa:before {
    content: '\\e909';
  }

  &.bff-confirmation:before {
    content: '\\e90b';
  }

  &.bff-copy:before {
    content: '\\e90d';
  }

  &.bff-custom-fields:before {
    content: '\\e952';
  }

  &.bff-arrow-down:before {
    content: '\\e90e';
  }

  &.bff-download:before {
    content: '\\e90f';
  }

  &.bff-caret-down:before {
    content: '\\e910';
  }

  &.bff-edit:before {
    content: '\\e912';
  }

  &.bff-ellipsis:before {
    content: '\\e913';
  }

  &.bff-embed:before {
    content: '\\e915';
  }

  &.bff-facebook-icon:before {
    content: '\\e917';
  }

  &.bff-font-type:before {
    content: '\\e918';
  }

  &.bff-general-settings:before {
    content: '\\e919';
  }

  &.bff-ingest:before {
    content: '\\e95d';
  }

  &.bff-reorder:before {
    content: '\\e91b';
  }

  &.bff-unlink:before {
    content: '\\e91c';
  }

  &.bff-insights:before {
    content: '\\e91e';
  }

  &.bff-integrations:before {
    content: '\\e91f';
  }

  &.bff-arrow-left:before {
    content: '\\e920';
  }

  &.bff-link:before {
    content: '\\e921';
  }

  &.bff-linked-in:before {
    content: '\\e922';
  }

  &.bff-manage-subscription:before {
    content: '\\e923';
  }

  &.bff-manage-versions:before {
    content: '\\e924';
  }

  &.bff-move:before {
    content: '\\e925';
  }

  &.bff-new-tab:before {
    content: '\\e980';
  }

  &.bff-notifications:before {
    content: '\\e927';
  }

  &.bff-paperclip:before {
    content: '\\e929';
  }

  &.bff-payment:before {
    content: '\\e92a';
  }

  &.bff-people:before {
    content: '\\e92b';
  }

  &.bff-person:before {
    content: '\\e92c';
  }

  &.bff-pin:before {
    content: '\\e92d';
  }

  &.bff-plus:before {
    content: '\\e92f';
  }

  &.bff-private:before {
    content: '\\e930';
  }

  &.bff-public:before {
    content: '\\e931';
  }

  &.bff-quote-end:before {
    content: '\\e932';
  }

  &.bff-quote-start:before {
    content: '\\e933';
  }

  &.bff-ratio-lock:before {
    content: '\\e934';
  }

  &.bff-refresh:before {
    content: '\\e935';
  }

  &.bff-refresh-spinning {
    animation: ${rotate} 1.5s linear infinite;

    &:before {
      content: '\\e935';
    }
  }

  &.bff-arrow-right:before {
    content: '\\e936';
  }

  &.bff-save:before {
    content: '\\e937';
  }

  &.bff-search:before {
    content: '\\e938';
  }

  &.bff-share:before {
    content: '\\e939';
  }

  &.bff-star-hollow:before {
    content: '\\e93b';
  }

  &.bff-star:before {
    content: '\\e93c';
  }

  &.bff-tool-tip:before {
    content: '\\e93d';
  }

  &.bff-trash:before {
    content: '\\e93e';
  }

  &.bff-twitter-icon:before {
    content: '\\e93f';
  }

  &.bff-upload:before {
    content: '\\e940';
  }

  &.bff-visit-media:before {
    content: '\\e942';
  }

  &.bff-warning:before {
    content: '\\e943';
  }

  &.bff-you-tube-icon:before {
    content: '\\e944';
  }

  &.bff-approve:before {
    content: '\\e945';
  }

  &.bff-tag:before {
    content: '\\e946';
  }

  &.bff-clock:before {
    content: '\\e947';
  }

  &.bff-merge:before {
    content: '\\e948';
  }

  &.bff-unapprove:before {
    content: '\\e949';
  }

  &.bff-grid-view:before {
    content: '\\e94a';
  }

  &.bff-list-view:before {
    content: '\\e94b';
  }

  &.bff-enter:before {
    content: '\\e94c';
  }

  &.bff-full-screen:before {
    content: '\\e94d';
  }

  &.bff-phone:before {
    content: '\\e94e';
  }

  &.bff-email:before {
    content: '\\e94f';
  }

  &.bff-attention:before {
    content: '\\e914';
  }

  &.bff-zip-file:before {
    content: '\\e950';
  }

  &.bff-square-orientation:before {
    content: '\\e90a';
  }

  &.bff-vertical-orientation:before {
    content: '\\e91a';
  }

  &.bff-panoramic-orientation:before {
    content: '\\e928';
  }

  &.bff-horizontal-orientation:before {
    content: '\\e93a';
  }

  &.bff-score-meter:before {
    content: '\\e941';
  }

  &.bff-location-marker:before {
    content: '\\e951';
  }

  &.bff-print:before {
    content: '\\e954';
  }

  &.bff-label:before {
    content: '\\e953';
  }

  &.bff-crop:before {
    content: '\\e955';
  }

  &.bff-zoom-out:before {
    content: '\\e956';
  }

  &.bff-zoom-in:before {
    content: '\\e957';
  }

  &.bff-comment:before {
    content: '\\e95a';
  }

  &.bff-check-in:before {
    content: '\\e958';
  }

  &.bff-check-out:before {
    content: '\\e959';
  }

  &.bff-chat:before {
    content: '\\e90c';
  }

  &.bff-brand-collective:before {
    content: '\\e95b';
  }

  &.bff-arrow-up:before {
    content: '\\e95c';
  }

  &.bff-caret-right:before {
    content: '\\e95e';
  }

  &.bff-caret-up:before {
    content: '\\e95f';
  }

  &.bff-credit-card:before {
    content: '\\e961';
  }

  &.bff-facebook-icon-square:before {
    content: '\\e962';
  }

  &.bff-linkedin-icon-square:before {
    content: '\\e963';
  }

  &.bff-cursor:before {
    content: '\\e964';
  }

  &.bff-filters:before {
    content: '\\e965';
  }

  &.bff-metadata:before {
    content: '\\e966';
  }

  &.bff-request-download:before {
    content: '\\e967';
  }

  &.bff-rules-engine:before {
    content: '\\e968';
  }

  &.bff-stealth:before {
    content: '\\e969';
  }

  &.bff-tip:before {
    content: '\\e96b';
  }

  &.bff-user-accepted:before {
    content: '\\e96c';
  }

  &.bff-user-invited:before {
    content: '\\e96d';
  }

  &.bff-dollar-sign:before {
    content: '\\e960';
  }

  &.bff-language:before {
    content: '\\e96f';
  }

  &.bff-knowledge-base:before {
    content: '\\e96e';
  }

  &.bff-user-admin:before {
    content: '\\e970';
  }

  &.bff-user-collaborator:before {
    content: '\\e971';
  }

  &.bff-user-guest:before {
    content: '\\e972';
  }

  &.bff-face-sad:before {
    content: '\\e911';
  }

  &.bff-face-happy:before {
    content: '\\e973';
  }

  &.bff-brand-guide:before {
    content: '\\e974';
  }

  &.bff-portal:before {
    content: '\\e975';
  }

  &.bff-notification-settings:before {
    content: '\\e976';
  }

  &.bff-user-settings:before {
    content: '\\e977';
  }

  &.bff-menu:before {
    content: '\\e978';
  }

  &.bff-remove:before {
    content: '\\e979';
  }

  &.bff-template-editor:before {
    content: '\\e97a';
  }

  &.bff-spinner-gif::after {
    content: url('https://cdn.brandfolder.io/27C9EC93/at/qdipip-a094w0-9udpnk/bff-spinner-gif.gif');
  }

  &.bff-show:before {
    content: '\\e916';
  }

  &.bff-hide:before {
    content: '\\e96a';
  }

  &.bff-form:before {
    content: '\\e97b';
  }

  &.bff-cloud-download:before {
    content: '\\e97c';
  }

  &.bff-draft:before {
    content: '\\e97d';
  }

  &.bff-press-release:before {
    content: '\\e97e';
  }

  &.bff-sent:before {
    content: '\\e97f';
  }

  &.bff-task:before {
    content: '\\e981';
  }

  &.bff-workspace:before {
    content: '\\e982';
  }

  &.bff-caret-left-double:before {
    content: '\\e983';
  }

  &.bff-caret-right-double:before {
    content: '\\e984';
  }

  &.bff-smartsheet:before {
    content: '\\e985';
  }

  &.bff-palette:before {
    content: '\\e986';
  }

  &.bff-info:before {
    content: '\\e989';
  }

  &.bff-priority-medium:before {
    content: '\\e988';
  }

  &.bff-priority-high:before {
    content: '\\e987';
  }

  &.bff-canva:before {
    content: '\\e98a';
  }

  &.bff-monitor:before {
    content: '\\e98b';
  }

  &.bff-video:before {
    content: '\\e98c';
  }

  &.bff-section:before {
    content: '\\e992';
  }

  &.bff-canvas:before {
    content: '\\e98d';
  }

  &.bff-image:before {
    content: '\\e98e';
  }

  &.bff-template:before {
    content: '\\e98f';
  }

  &.bff-instagram:before {
    content: '\\e990';
  }

  &.bff-pinterest:before {
    content: '\\e991';
  }

  &.bff-watermark:before {
    content: '\\e994';
  }

  &.bff-check-mark-circle:before {
    content: '\\e993';
  }

  &.bff-x-circle:before {
    content: '\\e997';
  }

  &.bff-add-page:before {
    content: '\\e995';
  }

  &.bff-alert:before {
    content: '\\e996';
  }

  &.bff-switch:before {
    content: '\\e998';
  }

  &.bff-organization:before {
    content: '\\e999';
  }

  &.bff-drag-indicator:before {
    content: '\\e99a';
  }

  &.bff-reports:before {
    content: '\\e99b';
  }

  &.bff-brandguide-v2:before {
    content: '\\e99c';
  }

  &.bff-connector:before {
    content: '\\e99d';
  }

  &.bff-lightbulb-filled:before {
    content: '\\e99e';
  }

  &.bff-sparkle-filled:before {
    content: '\\e99f';
  }

  &.bff-arrow-up-down:before {
    content: '\\e9a1';
  }

  &.bff-user-filled:before {
    content: '\\e9a0';
  }

  &.bff-check-circle-filled:before {
    content: '\\e9a3';
  }

  &.bff-columns:before {
    content: '\\e9a4';
  }

  &.bff-alert-filled:before {
    content: '\\e9a2';
  }
`;
/**
 * A component for Brandfolder's font icons.
 *
 * IMPORTANT: You will need to have Brandfolder's `@font-face` for font icons.
 * Consider using `<BrandfolderGlobalStyles>` component with `styled-components`.
 *
 * @param props FontIconProps
 * @returns FunctionComponent<FontIconProps>
 */ const FontIcon = (props)=>{
    const { 'aria-hidden': ariaHidden = true , color =fontIcon.FontIconColors.None , icon =fontIcon.FontIcons.Approve , position =fontIcon.FontIconPositions.None , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledFontIcon, _extends({}, otherProps, {
        "aria-hidden": ariaHidden,
        color: color,
        icon: icon,
        position: position
    })));
};

exports.FontIcon = FontIcon;
//# sourceMappingURL=font-icon.js.map
